import { InvoiceForm } from '@features/invoices/types/invoiceForm'
import { InvoiceFormLine } from '@features/invoices/types/invoiceForm/invoiceFormLine'
import { isInvoiceFormDepositLine } from '@features/invoices/utils/depositInvoices/isInvoiceFormDepositLine'
import { isInvoiceFormRowLine } from '@features/invoices/utils/isInvoiceFormRowLine'

export const getVatExemptedFormValues = (
  invoiceValues: InvoiceForm,
  defaultInvoiceValues: InvoiceForm,
): InvoiceForm => {
  const { invoiceLines, ...restValues } = invoiceValues

  // for vat exempted we should have 0% vat rate data in
  // the default values and that's what we need to ensure,
  // even if we load different data from the backend
  const [defaultLine] = defaultInvoiceValues?.invoiceLines
  const isDefaultLineRow = !!defaultLine && isInvoiceFormRowLine(defaultLine)
  if (!isDefaultLineRow) {
    return invoiceValues
  }

  const formattedLines: InvoiceFormLine[] = invoiceLines.map((invoiceLine) => {
    const isInvoiceLineRow = isInvoiceFormRowLine(invoiceLine)
    if (!isInvoiceLineRow && !isInvoiceFormDepositLine(invoiceLine)) {
      return invoiceLine
    }

    const { totalIncludingVat, ...line } = invoiceLine || {}

    return {
      ...line,
      totalIncludingVat: line.totalExcludingVat,
      vatRateId: defaultLine.vatRateId,
      vatRatePercent: defaultLine.vatRatePercent,
    }
  })

  return { invoiceLines: formattedLines, ...restValues }
}
